import React from 'react';
import ModuleRoute from 'holocron-module-route';

import ErrorLayout from './components/ErrorHandling/ErrorLayout';
import ErrorMessage from './components/ErrorHandling/ErrorMessage';
import requireAuthHub from './hooks/requireAuthHub';

const childRoutes = (store) => [
  <ModuleRoute path="demo/:moduleName" moduleName="axp-demo" key="axp-demo" />,
  <ModuleRoute path="/" key="routes">

    <ModuleRoute
      moduleName="axp-manage-bookings-container"
    >
      <ModuleRoute onEnter={requireAuthHub(store)}>
        <ModuleRoute
          path="(:locale)/travel/my-bookings/summary"
          moduleName="axp-manage-bookings-summary"
          title="Bookings | American Express"
        />
        <ModuleRoute
          path="(:locale)/travel/my-bookings/trip-overview"
          moduleName="axp-manage-bookings-overview"
          title="Overview"
        />
        <ModuleRoute
          path="(:locale)/travel/my-bookings/hotel-cancellation/:tripId/:bookingDate"
          moduleName="axp-manage-bookings-hotel-cancellation"
          title="Hotel Cancellation"
        />
        <ModuleRoute
          path="(:locale)/travel/my-bookings/lowest-rate-guaranteed-claim"
          moduleName="axp-manage-bookings-lowest-rate-guaranteed-claim"
          title="Hotel LRG Claim"
        />
        <ModuleRoute
          path="(:locale)/travel/my-bookings/change-hotel-dates"
          moduleName="axp-manage-bookings-hotel-date-change"
          title="Change Hotel Dates"
        />
        <ModuleRoute
          path="(:locale)/travel/my-bookings/car-cancellation/:tripId/:bookingDate"
          moduleName="axp-manage-bookings-car-cancellation"
          title="Car Cancellation"
        />
        <ModuleRoute
          path="(:locale)/travel/my-bookings/air-cancellation/:tripId/:bookingDate"
          moduleName="axp-manage-bookings-air-cancellation"
          title="Air Cancellation"
        />
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute component={ErrorLayout} key="error-layout">
    <ModuleRoute
      code="500"
      component={ErrorMessage}
      path="*/error"
      title="Load Error"
      httpStatus={500}
    />
    <ModuleRoute
      code="404"
      component={ErrorMessage}
      path="*"
      title="Not Found"
      httpStatus={404}
    />
  </ModuleRoute>,
];

export default childRoutes;
